
<div class="banner-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="banner-text text">
                    <h1>Assigned  <span>Candidate</span> List</h1>
                    <p>Connecting Worldwide Talents and Businesses</p>

                    <div class="banner-form-area">
                        <form>
                            <div class="row">

                                <div class="col-lg-6">
                                    <div class="form-group mt-2">
                                        <ngx-select-dropdown
                                        [config]="CountryConfig"
                                        [options]="country_list"
                                        (change)="onSelectedCountry($event)"
                                    >
                                    </ngx-select-dropdown>
                                    </div>
                                </div>
    
                                <div class="col-lg-6">
                                    <div class="form-group mt-2">
                                        <ngx-select-dropdown
                                        [config]="CitiesConfig"
                                        [options]="city_list"
                                        (change)="onSelectedCity($event)"
                                    >
                                    </ngx-select-dropdown>
                                    </div>
                                </div>


                                <div class="col-lg-6 mt-4 mb-4">
                                    <div class="form-group">
                                        <label
                                            ><i class="fas fa-user-alt"></i
                                        ></label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Name"
                                            [ngModelOptions]="{
                                                standalone: true
                                            }"
                                            [(ngModel)]="name"
                                            style="border: 2px solid #cacacd; border-radius: 4px; padding-left: 10px;"
                                        />
                                    </div>
                                </div>

                                      <div class="col-lg-6 mt-4 mb-4">
                                    <div class="form-group">
                                        <label
                                            ><i class="fa fa-envelope"></i
                                        ></label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Email"
                                            [ngModelOptions]="{
                                                standalone: true
                                            }"
                                            [(ngModel)]="candidateEmail"
                                            style="border: 2px solid #cacacd; border-radius: 4px; padding-left: 10px;"
                                        />
                                    </div>
                                </div>

                                <!-- <div class="col-lg-4">
                                    <div class="form-group">
                                        <label
                                            ><i class="fa fa-envelope"></i
                                        ></label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Email"
                                            [ngModelOptions]="{
                                                standalone: true
                                            }"
                                            [(ngModel)]="email"
                                        />
                                    </div>
                                </div> -->


                            </div>

                            <button
                                type="submit"
                                (click)="getAllCandidatesAssignedToEmployer()"
                                class="btn banner-form-btn mt-4 me-3"
                            >
                                Search
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<!-- calendly.component.html -->
<!-- <div class="calendly-widget-container"> -->
    <!-- The badge widget will automatically load here -->
  <!-- </div> -->


  <!-- <div class="container back-link">
    <a routerLink="/employer/employer-profile" class="cursor_pointer h5"><i class="fa fa-angle-double-left me-2"></i>Back</a>
</div> -->
  <div class="container">
        <h5 class="text-success total-job-listing">Total Candidate Listings: {{totalItems > 0 ? totalItems : 0}} </h5>
    </div>
  
<section class="profile-area profile-area-two pt-100">
    <div class="container">
        <div class="row">
            <div class="col-sm-6 col-lg-6" *ngFor="let data of candidateList">
                <div class="profile-item wow fadeInUp" data-wow-delay=".3s">
                    <!-- <ng-container *ngIf="data?.candidateImageDetails?.imageUrl && data.candidateImageDetails.imageUrl.trim() !== ''; else avatarImage">
                        <img [src]="data?.candidateImageDetails?.imageUrl" class="profile_images" alt="Profile">
                    </ng-container>
                    <ng-template #avatarImage>
                        <img src="../../../assets/dummy/dummy-candidate.png" class="profile_images" alt="Profile">
                    </ng-template> -->
                    <div class="profile-inner">
                        <ng-container *ngIf="data?.firstName || data?.middleName || data?.lastName ; else defaultName">
                            <h3>{{ data?.firstName }} {{ data?.middleName }} {{ data?.lastName }}</h3>
                        </ng-container>
                        <ng-template #defaultName>
                            <h3>{{data?.publicName}}</h3>
                        </ng-template>
                        <!-- <h3>{{data?.publicName}}</h3> -->
                        <span> <i class="fas fa-building text-success"></i> {{data?.category ? data?.category : "******"}}</span>
                        <span *ngIf="data?.country && data.country !== 'undefined'">
                            <span *ngIf="data?.country && data.country !== 'undefined'">
                                <i class="fa fa-globe text-success"></i>
                                {{ data?.country }} <span *ngIf="data?.city">({{data?.city}})</span> 
                            </span>
                    </span>

                        <span class="mt-3 ">
                            <b>Experience</b
                            >:
                            <ng-container *ngIf="data?.yearsOfExperience?.length > 0 ; else noData">
                            <div
                                *ngIf="data?.yearsOfExperience"
                                class="mt-2"
                            >
                                <span>
                                    <ol class="experience-list">
                                    <li
                                        *ngFor="
                                            let experience of data.yearsOfExperience
                                        "
                                    >
                                        <div
                                            class="d-flex  w-100"
                                        >
                                            <div>
                                                <h6>
                                                    {{
                                                        experience.jobTitle
                                                    }}
                                                </h6>
                                                <!-- <p>
                                                    {{
                                                        experience.companyName
                                                    }}
                                                </p> -->
                                            </div>
                                            <div>
                                                <ng-container
                                                    *ngIf="
                                                        experience?.endedMonth &&
                                                            experience?.endedYear;
                                                        else presentTemplate
                                                    "
                                                >
                                                    <h6>
                                                        ({{
                                                            experience?.startedYear
                                                        }}) - ({{
                                                            experience?.endedYear
                                                        }})
                                                    </h6>
                                                </ng-container>

                                                <ng-template
                                                    #presentTemplate
                                                >
                                                    <div>
                                                        <h6>
                                                            ({{
                                                                experience?.startedYear
                                                            }}) - present
                                                        </h6>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </li>
                                </ol>
                                </span>
                            </div>
                        </ng-container>
                        <ng-template #noData>
                         <p>********</p>
                        </ng-template>
                        </span>

                        <div>
                            <ul class="mt-3 unordered-list">
                                <ng-container *ngIf="data?.skills?.length > 0; else noSkills">
                                    <b>Skills</b>
                                    <div *ngFor="let skills of data?.skills">
                                    <span>
                                 
                                           {{skills?.skill}}
                                    </span>
                                </div>
                                </ng-container>
                            </ul>
                            <ng-template #noSkills>
                                <p><b>Skills</b> :</p>
                                <span>********</span>
                            </ng-template>
                        </div>

                        <a  [routerLink]="['/employer/assigned-candidate-detail',data?._id]">View Profile<i class="icofont-swoosh-right"></i></a>
                        <div class="profile-heart mt-2">
                    </div>
                    </div>
                </div>
            </div>
            <div *ngIf="candidateList.length === 0" class="col-12 text-center mt-5">
                <p>No Data Found</p>
            </div>
            
        </div>
    </div>


    <!-- Modal for updating status -->
    <div class="modal fade" id="statusModal" tabindex="-1" aria-labelledby="statusModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="statusModalLabel">Update Status</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <form >
                    <div class="modal-body">
                        <div class="col-lg-12">
                            <label for="statusSelector" class="form-label">Select Status</label>
                            <ngx-select-dropdown
                                            [config]="statusConfig"
                                            [options]="jobStatus"
                                            (change)="onChangeStatus($event)"
                                        ></ngx-select-dropdown>
                        </div>
                    </div>
                    
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        <!-- <button type="submit" class="btn btn-primary" (click)="updateJobStatus()">Save Changes</button> -->
                    </div>
                </form>
            </div>
        </div>
    </div>


    <nav aria-label="Page navigation example pagination" class="pagination-nav">
        <ul class="pagination">
            <li class="page-item" [class.disabled]="currentPage === 1">
                <a
                    class="page-link pointer"
                    (click)="onPageChange(currentPage - 1)"
                    aria-label="Previous"
                >
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>
            <li
                class="page-item"
                *ngFor="
                    let page of [].constructor(totalPages);
                    let i = index
                "
            >
                <a
                    class="page-link pointer"
                    (click)="onPageChange(i + 1)"
                    >{{ i + 1 }}</a
                >
            </li>
            <li
                class="page-item"
                [class.disabled]="currentPage === totalPages"
            >
                <a
                    class="page-link pointer"
                    (click)="onPageChange(currentPage + 1)"
                    aria-label="Next"
                >
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>
        </ul>
    </nav>
    
    <div class="pagination-controls pagination">
        <span>Page {{ currentPage }} of {{ totalPages }}</span>
    </div>
</section>





